export const formatDateString = (dateString: string): string => {
  const [year, month, day] = dateString.split('-');
  return `${day}/${month}/${year}`;
};

/**
 * Faz parse de uma string de data YYYY-MM-DD para um objeto Date
 * sem problemas de timezone (usa horário local, não UTC)
 */
export const parseDateStringLocal = (dateString: string): Date => {
  const [year, month, day] = dateString.split('-').map(Number);
  return new Date(year, month - 1, day);
};

/**
 * Compara duas datas no formato YYYY-MM-DD
 * Retorna true se endDate é posterior a startDate
 */
export const isEndDateAfterStartDate = (startDate: string, endDate: string): boolean => {
  const start = parseDateStringLocal(startDate);
  const end = parseDateStringLocal(endDate);
  return end > start;
};
